import { FilterChips } from "@/design-system/components/ui";

// Partner Brand Ownership — the ONE Mine/Everyone scope for the whole
// Prequalification tab (D3).
//
// It replaces the two separate chip groups that used to sit above the
// invitations list and the in-progress list. Two controls for the same question
// meant the two lists could be showing different populations while looking like
// one screen, and neither of them governed completions at all.
//
// Owned by the SHELL and rendered in the tab header, above the tab bar — which
// is what makes it read as "this applies to everything below", and what lets a
// panel treat `mineOnly` as read-only state it never has to reconcile.
//
// 🔴 The default is FALSE — "Everyone on this site". That is a change from the
// two toggles this replaced, both of which defaulted to Mine, and it is
// deliberate: an ORGANIC completion (somebody who found the public funnel
// themselves) has no sender, so "Mine" excludes it by construction. With
// Completions as the opening tab, a Mine default would greet a partner with a
// list that silently omits every lead their branded site earned on its own.

export interface PrequalScopeControlProps {
  mineOnly: boolean;
  onChange: (mineOnly: boolean) => void;
}

export function PrequalScopeControl({ mineOnly, onChange }: PrequalScopeControlProps) {
  return (
    <FilterChips
      label="Whose prequalifications"
      activeId={mineOnly ? "mine" : "all"}
      onChange={(id) => onChange(id === "mine")}
      chips={[
        // Widest first, matching the default.
        { id: "all", label: "Everyone on this site" },
        { id: "mine", label: "Mine" },
      ]}
    />
  );
}
